export enum FeedAnimation {
  Autoplay = 'autoplay',
  OnHover = 'onHover',
  Pulse = 'pulse',
  ParallelAutoplay = 'parallelAutoplay',
}

export const FEED_WIDGET_ELEMENT_NAME = 'pimster-feed-widget';
export const PATH_CONFIG_KEY = 'options';
